import { useForm } from '@inertiajs/react'
import type { FormEvent } from 'react'
import AuthLayout from '@/layouts/AuthLayout'

interface EmailConfirmationProps {
  confirmed: boolean
  valid?: boolean
  token?: string
  error?: string
}

export default function EmailConfirmation({ confirmed, valid, token, error }: EmailConfirmationProps) {
  const { post, processing } = useForm({ token: token ?? '' })

  function handleConfirm(e: FormEvent) {
    e.preventDefault()
    post('/email_confirmation')
  }

  if (confirmed) {
    return (
      <AuthLayout title="Email confirmed">
        <div className="card bg-base-100 shadow-lg">
          <div className="card-body items-center text-center">
            <span className="iconify lucide--check-circle size-12 text-success mb-2" />
            <h2 className="card-title text-xl font-bold">Email confirmed</h2>
            <p className="text-base-content/70">
              Your email has been verified. You can now log in to your account.
            </p>
            <div className="mt-4">
              <a href="/login" className="btn btn-primary">
                Log in
              </a>
            </div>
          </div>
        </div>
      </AuthLayout>
    )
  }

  if (valid) {
    return (
      <AuthLayout title="Confirm your email">
        <div className="card bg-base-100 shadow-lg">
          <div className="card-body items-center text-center">
            <span className="iconify lucide--mail-check size-12 text-primary mb-2" />
            <h2 className="card-title text-xl font-bold">Confirm your email</h2>
            <p className="text-base-content/70">
              Click the button below to verify your email address and activate your account.
            </p>
            <form onSubmit={handleConfirm} className="mt-4">
              <button type="submit" className="btn btn-primary" disabled={processing}>
                {processing ? 'Confirming…' : 'Confirm my email'}
              </button>
            </form>
          </div>
        </div>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout title="Confirmation failed">
      <div className="card bg-base-100 shadow-lg">
        <div className="card-body items-center text-center">
          <span className="iconify lucide--x-circle size-12 text-error mb-2" />
          <h2 className="card-title text-xl font-bold">Confirmation failed</h2>
          <p className="text-base-content/70">
            {error || 'Invalid or expired confirmation link.'}
          </p>
          <div className="mt-4">
            <a href="/login" className="link link-primary text-sm">
              Back to login
            </a>
          </div>
        </div>
      </div>
    </AuthLayout>
  )
}
